export const en = {
  imageGalleryPage: {
    page_title: 'Gallery',
    header: {
      title: 'Image Gallery',
      description:
        'Pictures from previous volunteering activity throughout your company',
      greenshield_disclaimer:
        'Please note that photographs captured during Purposely events may be used for internal and external communications purposes. This may include use on our intranet, newsletters, reports, presentations, social media channels, and other corporate materials.',
    },
    my_photos: {
      title: 'My Photos',
      empty_state: {
        title: "You haven't uploaded any photos yet",
        description:
          'Complete an opportunity and upload photos to see them here',
      },
      view_all: 'View All',
      photo_count: '+{{count}} photos',
    },
    albums: {
      title: 'Photos from other events at your company',
      filter: {
        all_opportunities: 'All opportunities',
        your_opportunities: 'Your opportunities',
      },
      results_count: '{{count}} Results',
      empty_state: {
        all: {
          title: 'No company albums yet',
          description:
            'When your company completes an opportunity, any uploaded photos will live here',
        },
        yours: {
          title: 'No albums yet',
          description:
            'When you complete an opportunity, upload photos to see them here',
        },
      },
      photo_count: '{{count}} Photos',
    },
    upload_modal: {
      title: 'Upload Photos to {{eventName}}',
      description: 'Share photos from this event to everyone at {{companyName}}',
      greenshield_disclaimer:
        'Please note that photographs captured during Purposely events may be used for internal and external communications purposes. This may include use on our intranet, newsletters, reports, presentations, social media channels, and other corporate materials.',
      submit: 'Submit',
    },
  },
}
